import { find } from 'lodash';
import { DesignObjectModel } from '../../model/design-object.model';

export const findLinkedDataById = (linkedDataId: string, design: DesignObjectModel) => design && design.linkedData && find(design.linkedData, {id: linkedDataId});
